import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../lib/request";

export const searchStates = createAsyncThunk(
  "states/search",
  async ({ countryId, query = "", page = 0, size = 150 }, { rejectWithValue }) => {
    try {

      let url = `/authn/state/${countryId}/search?page=${page}&size=${size}`;

      if (query.trim() !== "") {
        url += `&q=${encodeURIComponent(query.trim())}`;
      }

      const response = await get(url, null, {
        skipAuth: false,
      });

      return Array.isArray(response) ? response : [];

    } catch (error) {

      console.error("State API error:", error);

      return rejectWithValue(
        error?.message || "Failed to fetch states"
      );

    }
  }
);

const statesSlice = createSlice({
  name: "states",

  initialState: {
    states: [],
    loading: false,
    error: null,
  },

  reducers: {

    clearStates: (state) => {

      state.states = [];
      state.loading = false;
      state.error = null;

    },

  },

  extraReducers: (builder) => {

    builder

      .addCase(searchStates.pending, (state) => {

        state.loading = true;
        state.error = null;

      })

      .addCase(searchStates.fulfilled, (state, action) => {

        state.loading = false;
        state.states = action.payload || [];

      })

      .addCase(searchStates.rejected, (state, action) => {

        state.loading = false;
        state.error = action.payload;

      });

  },

});

export const { clearStates } = statesSlice.actions;

export default statesSlice.reducer;
